import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

/**
 * ComingSoonPage — minimal placeholder used by all newly-introduced
 * PrimeS4 AI top-level routes during Phase 1 (routing foundation).
 *
 * Detailed layouts/marketing content will be built page-by-page in later
 * phases. For now this only renders:
 *   - the existing site Header (so the new global PrimeS4 nav is reachable)
 *   - a centred page title + eyebrow + "Coming Soon" body
 *   - the existing site Footer
 */
const ComingSoonPage = ({ title, eyebrow, description }) => {
  const testId = `coming-soon-${(title || "page")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "")}`;

  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid={testId}>
      <Header />
      <main className="flex-1 flex items-center">
        <div className="w-full max-w-3xl mx-auto px-6 py-24 text-center">
          {eyebrow ? (
            <p
              className="text-[11px] font-semibold tracking-[0.22em] text-[#025979] uppercase mb-4"
              data-testid={`${testId}-eyebrow`}
            >
              {eyebrow}
            </p>
          ) : null}
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#111827] leading-[1.05]"
            style={{ fontFamily: "Chivo, sans-serif" }}
            data-testid={`${testId}-title`}
          >
            {title}
          </h1>
          <p
            className="mt-6 text-base sm:text-lg text-[#4B5563] leading-relaxed"
            data-testid={`${testId}-description`}
          >
            {description || "This page is part of the new PrimeS4 AI ecosystem. Coming Soon."}
          </p>
          <div
            className="mt-10 inline-flex items-center gap-2 rounded-sm border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-2 text-xs font-semibold tracking-wide text-[#025979] uppercase"
            data-testid={`${testId}-badge`}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#025979]" />
            Coming Soon
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ComingSoonPage;
